import React from 'react';
export function CTAButton() {
  return <a href="https://getpurenutra.co/products/purenutra%C2%AE-10-1-alpha-gummies" className="inline-block px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg text-lg transition-colors duration-200 shadow-md hover:shadow-lg" data-id="element-12">
      GET YOUR ALPHA GUMMIES NOW
    </a>;
}